<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid" v-if="loading">
        <div class="p-col-9"><Skeleton height="25px" /></div>
        <div class="p-col-3"><Skeleton height="25px" /></div>
        <div class="p-col-7" v-if="subtitle"><Skeleton /></div>
      </div>
      <div v-else class="p-grid p-jc-between">
        <div class="p-col-fixed title">
          {{ title }}
        </div>
        <div class="p-col count-container">
          <span
            class="count"
            :style="{
              color: valueColor,
              backgroundColor: valueBackgroundColor,
            }"
            >{{ value }}</span
          >
        </div>
        <div class="p-col-12" v-if="subtitle">
          <span class="subtitle">{{ subtitle }}</span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: 'AppWidgetCount',
  props: {
    value: {
      type: [Number, String],
      default: () => 0,
      required: true,
    },
    valueColor: {
      type: String,
    },
    valueBackgroundColor: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    loading: Boolean,
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0 !important;
}

div >>> .p-card-body {
  padding-bottom: 0.5rem;
}

.title {
  font-size: 1.3rem;
}

.count {
  font-size: 1.3rem;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 3px;
}

.count-container {
  text-align: right;
  padding-right: 0;
  padding-left: 0;
}

.subtitle {
  color: #787d81;
}

@media (max-width: 320px) {
  .title {
    font-size: 1rem;
  }
  .count {
    font-size: 1rem;
  }
}
</style>
